import {mapGetters} from 'vuex';

import * as constants from '../constants';

import MixinShippingPrice from './shipping-price';
import MixinStorage from './storage';
import Utils from '../modules/utils';

export default {
  name: 'MixinCookies',
  computed: {
    Utils() {
      return Utils;
    },
    ...mapGetters([
      'formData',
      'paymentId',
      'recurrence',
      'paymentMethod',
      'currentChoiceConfig',
      'currentOrderUid',
      'coregs',
      'currentPageId'
    ])
  },
  mixins: [
    MixinStorage,
    MixinShippingPrice
  ],
  methods: {
    /**
     * If we or on the initial order form, store cookies
     * - form data
     * - palyance payment UID
     * - payment type
     * - choice type
     * - choice config
     */
    storeCookiesBeforeRedirectingToConfirmPage() {
      // Regular order form: initial and cross-sell
      this.$cookies.set('CUSTOMER_INFO', this.formData);
      this.$cookies.set('PALYANCE_PAYMENT_ID', this.paymentId);
      this.$cookies.set('PAYMENT_METHOD', this.paymentMethod);
      this.$cookies.set('RECURRENCE', this.recurrence);
      this.$cookies.set('PREVIOUS_CHOICE_TYPE', constants.ORDER_STEP_INITIAL);

      /**
       * We need to be in a regular (app) mode, not multiple ! This will fail in multiple
       * because we don't store the previousChoice in the localStorage/cookie
       */
      if (typeof this.currentChoiceConfig !== 'undefined') {
        this.setStoragePreviousChoice(this.getCurrentChoiceForCookie());
      }

      this.$cookies.set('PREVIOUS_ORDER_ID', this.currentOrderUid);

      // Store initial information
      if (typeof this.currentChoiceConfig !== 'undefined' && this.currentChoiceConfig.type === constants.ORDER_STEP_INITIAL) {
        this.$cookies.set('COREGS', JSON.stringify(this.coregs));
      }

      // Campaign stats - store previous page id
      this.$cookies.set('PREVIOUS_PAGE_ID', this.currentPageId);

      if (typeof this.formData.billing.billingEmail !== 'undefined') {
        this.setStorageHemail(this.Utils.hashEmail(this.formData.billing.billingEmail));
      }
    },
    /**
     * Filter choice data to store in cookie
     * @return {object}
     */
    getCurrentChoiceForCookie() {
      return {
        choiceId: this.currentChoiceConfig.choiceId,
        productId: this.currentChoiceConfig.productId,
        productCode: this.currentChoiceConfig.productCode,
        isBcl: this.currentChoiceConfig.isBcl,
        type: this.currentChoiceConfig.type,
        name: this.currentChoiceConfig.name,
        paymentMethod: this.currentChoiceConfig.paymentMethod,
        price: this.currentChoiceConfig.price,
        shippingPrice: this.getCurrentShippingPrice(),
        shippingLabel: this.currentChoiceConfig.shippingPriceLabel,
        timestamp: (new Date()).getTime(),
        quantity: this.currentChoiceConfig.quantity,
        affiliateId: this.currentChoiceConfig.affiliateId,
        description: this.currentChoiceConfig.description,
        longDescription: this.currentChoiceConfig.longDescription,
        recordTypeId: this.currentChoiceConfig.recordTypeId,
        displayOptOut: this.currentChoiceConfig.displayOptOut,
        defaultPrice: this.currentChoiceConfig.defaultPrice,
        startingPrice: this.currentChoiceConfig.startingPrice,
        startingPriceDuration: this.currentChoiceConfig.startingPriceDuration,
        initialTermLength: this.currentChoiceConfig.initialTermLength,
        renewalTermLength: this.currentChoiceConfig.renewalTermLength,
        productName: this.currentChoiceConfig.productName,
        bundleName: this.currentChoiceConfig.bundleName,
        freeDays: this.currentChoiceConfig.freeDays
      };
    }
  }
};



// WEBPACK FOOTER //
// ./src/common/mixins/cookies.js